import { withStyles } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import appConstant from "../../appConstants";
import HeadsetMicIcon from "@material-ui/icons/HeadsetMic";
import { compose } from "recompose";

const styles = (theme) => ({
  moduleSwitcherMenu: {
    background: theme.ModalBGColor,
    borderRadius: "0px 0px 4px 4px",
    marginTop: "30px",
    padding: "4px",
  },
  menuItem: {
    fontSize: "14px",
    lineHeight: "19px",
    color: theme.gridTextColor,
    padding: "4px 12px 4px 0px",
    fontWeight: "bold",
  },
  iconStyle: {
    padding: "0px 10px",
    fontSize: "20px",
    color: theme.HeaderSelectedText,
  },
  dispatchIconstyle: {
    marginRight: ".2em",
    marginLeft: ".2em",
  },
});
const ModuleSwitcher = (props) => {
  const { menuAnchor, onClose, handleModuleChange, classes , userProfile} =
    props;
  const reportUrl = appConstant.NAV_URLS.REPORT_DUPLICATE_CUSTOMERS;
    
  function onModuleChange(event, moduleURL) {
    handleModuleChange(event, moduleURL);
    onClose();
  }
  
  return (
    <div>
      <Menu
        disablePortal={true}
        getContentAnchorEl={null}
        disableAutoFocusItem={true}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(menuAnchor)}
        anchorEl={menuAnchor}
        onClose={onClose}
        MenuListProps={{ disablePadding: true }}
        classes={{
          paper: classes.moduleSwitcherMenu,
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          className={classes.menuItem}
          onClick={(e) =>
            onModuleChange(e, appConstant.NAV_URLS.IBPLANNING_SHIPMENTS)
          }
          data-automationid="planning"
        >
          <i className={`${classes.iconStyle} icon-ib-planning`} />
          Planning
        </MenuItem>
        <MenuItem
          className={classes.menuItem}
          onClick={(e) => onModuleChange(e, appConstant.NAV_URLS.DISPATCH_HOME)}
          data-automationid="Dispatch"
          disabled={!userProfile.enableDispatch}
        >
          <HeadsetMicIcon
            className={`${classes.iconStyle} ${classes.dispatchIconstyle}`}
          />
          Dispatch
        </MenuItem>
        <MenuItem
          className={classes.menuItem}
          onClick={(e) => onModuleChange(e, reportUrl)}
          data-automationid="reports"
        >
          <i className={`${classes.iconStyle} icon-icon_analyse`} />
          Reports
        </MenuItem>
      </Menu>
    </div>
  );
};

export default compose(withStyles(styles))(ModuleSwitcher);
